import { useState } from "react";
import { Input } from "./ui";

export function TagsInput({ value, onChange, suggestions = [], placeholder }: { value: string[]; onChange: (v: string[]) => void; suggestions?: string[]; placeholder?: string }) {
  const [draft, setDraft] = useState("");
  const add = (raw: string) => {
    const next = [...value];
    for (const t of raw.split(",").map((x) => x.trim()).filter(Boolean)) {
      if (!next.some((x) => x.toLowerCase() === t.toLowerCase())) next.push(t);
    }
    onChange(next);
    setDraft("");
  };
  return (
    <div className="space-y-2">
      <Input list="tag-suggestions" value={draft} placeholder={placeholder} onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => { if ((e.key === "Enter" || e.key === ",") && draft.trim()) { e.preventDefault(); add(draft); } }}
        onBlur={() => draft.trim() && add(draft)} />
      <datalist id="tag-suggestions">{suggestions.filter((s) => !value.includes(s)).map((s) => <option key={s} value={s} />)}</datalist>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {value.map((t) => (
            <span key={t} className="inline-flex items-center gap-1 rounded-full bg-stone-100 px-2 py-0.5 text-xs">
              {t}
              <button type="button" aria-label={`remove ${t}`} className="text-stone-500 hover:text-stone-900" onClick={() => onChange(value.filter((x) => x !== t))}>×</button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
